import type { editor } from 'monaco-editor'
import type { EditorErrorMarker } from '../error-marker-context'

/** Owner key for setModelMarkers — namespaces our markers away from language services. */
export const ERROR_MARKER_OWNER = 'bctci-user-error'

// Inlined Monaco enum values so this module never loads Monaco at runtime
// (jsdom tests import it directly).
const MARKER_SEVERITY_ERROR = 8 // MarkerSeverity.Error
const STICKINESS_NEVER_GROWS = 1 // TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges

/**
 * Marker (squiggle + hover message) covering the failing line.
 * `lineLength` comes from model.getLineLength(line); the end column is
 * clamped to at least 2 so empty lines still get a visible marker.
 */
export function buildMonacoMarkerData(
  marker: EditorErrorMarker,
  lineLength: number,
): editor.IMarkerData {
  return {
    severity: MARKER_SEVERITY_ERROR,
    message: marker.message,
    startLineNumber: marker.line,
    startColumn: 1,
    endLineNumber: marker.line,
    endColumn: Math.max(2, lineLength + 1),
  }
}

/**
 * Whole-line decoration: red strip in the line-decorations gutter plus a
 * faint line background. Styled in styles/editor.css.
 */
export function buildLineDecoration(
  line: number,
): editor.IModelDeltaDecoration {
  return {
    range: {
      startLineNumber: line,
      startColumn: 1,
      endLineNumber: line,
      endColumn: 1,
    },
    options: {
      isWholeLine: true,
      className: 'bctci-error-line',
      linesDecorationsClassName: 'bctci-error-line-gutter',
      stickiness: STICKINESS_NEVER_GROWS,
    },
  }
}
